const ApiTokenStatus = {
  ACTIVE: 'Active',
  REVOKED: 'Revoked',
};

export default ApiTokenStatus;
